(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7130],{

/***/ 46441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopyOutlined');

/***/ }),

/***/ 30677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DialpadOutlined');

/***/ }),

/***/ 95502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M13.25 16.74c0 .69-.53 1.26-1.25 1.26-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.55 1.25 1.25M11.99 6c-1.77 0-2.98 1.15-3.43 2.49l1.64.69c.22-.67.74-1.48 1.8-1.48 1.62 0 1.94 1.52 1.37 2.33-.54.77-1.47 1.29-1.96 2.16-.39.69-.31 1.49-.31 1.98h1.82c0-.93.07-1.12.22-1.41.39-.72 1.11-1.06 1.87-2.17.68-1 .42-2.36-.02-3.08-.51-.84-1.52-1.51-3-1.51M19 5H5v14h14zm0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
}), 'HelpCenterOutlined');

/***/ }),

/***/ 12192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
}), 'PaymentOutlined');

/***/ }),

/***/ 59744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 10h-4.59l.58-3.41v-.2c-.01-.26-.12-.51-.3-.7L12 5l-4.6 5c-.27.26-.42.62-.4 1v5c0 1.1.9 2 2 2h5.5c.56.03 1.08-.29 1.3-.8l2.1-4.9c.08-.15.12-.33.1-.5V11c0-.55-.45-1-1-1"
}, "1")], 'RecommendOutlined');

/***/ }),

/***/ 12802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage/[...location]",
      function () {
        return __webpack_require__(53461);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/chevron-down.e5a5a334.svg","height":20,"width":20});

/***/ }),

/***/ 83664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CanonicalURL; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55088);




function CanonicalURL() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: (0,_utility__WEBPACK_IMPORTED_MODULE_3__/* .getCanonicalURL */ .DN)(router)
        })
    });
}


/***/ }),

/***/ 18228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadInvender */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var loadInvender = function(invendrKey, pageKey) {
    var script = document === null || document === void 0 ? void 0 : document.createElement("script");
    if (script && invendrKey && invendrKey !== window.location.pathname) {
        script.src = "https://dev-invendr-dni.devv.ca/api/script/".concat(invendrKey, ".js?callback=get_invendr_data");
        script.id = pageKey;
        script.async = true;
        if (typeof pageKey === "string" && document.querySelectorAll("#".concat(pageKey)).length < 1) {
            document.body.appendChild(script);
        }
    // on refresh update invendr
    // removeInvendrDom();
    }
};
var InvendrScript = function(props) {
    var invendrKey = props.invendrKey, pageKey = props.pageKey;
    if (true) {
        window.get_invendr_data = function(data) {
            window.invendrData = data;
        };
        loadInvender(invendrKey, pageKey);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        next_router__WEBPACK_IMPORTED_MODULE_1__.Router.events.on("routeChangeComplete", loadInvender);
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_1__.Router.events.off("routeChangeComplete", loadInvender);
        // removeInvendrDom();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (InvendrScript);


/***/ }),

/***/ 41165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var tConvert = function(time) {
    var timeCal = (time === null || time === void 0 ? void 0 : time.toString().match(/^(0?[0-9]|1[0-9]|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/)) || [
        time
    ];
    if ((timeCal === null || timeCal === void 0 ? void 0 : timeCal.length) > 1) {
        var myMoment = moment__WEBPACK_IMPORTED_MODULE_0___default()(time, "HH:mm");
        var minutesFormat = myMoment === null || myMoment === void 0 ? void 0 : myMoment.format("h:mma");
        if (minutesFormat === null || minutesFormat === void 0 ? void 0 : minutesFormat.includes("00")) {
            return myMoment === null || myMoment === void 0 ? void 0 : myMoment.format("ha");
        }
        return minutesFormat;
    }
    return time === null || time === void 0 ? void 0 : time.join("");
};
// eslint-disable-next-line consistent-return
var convertTimeFormat = function(value, locale, text) {
    if (!value && locale === "fr") return "Ferm\xe9";
    if (!value) return "Closed";
    if (value === "Open 24 hours") {
        return locale === "en" ? "24 hours" : "24 h/24";
    }
    var trimSpace = value.replace(/\s/g, "");
    var hoursSplit = trimSpace.split("-");
    if (hoursSplit.length !== 2) {
        return value;
    }
    var openTime = hoursSplit[0].split(":")[0].length > 1 ? hoursSplit[0].replace(/^0?/, "") : hoursSplit[0];
    var closeTime = hoursSplit[1].split(":")[0].length > 1 ? hoursSplit[1].replace(/^0?/, "") : hoursSplit[1];
    // 9 h 18 h
    if (locale === "fr") {
        if (openTime === null || openTime === void 0 ? void 0 : openTime.includes(":00")) openTime = openTime === null || openTime === void 0 ? void 0 : openTime.split(":")[0];
        if (closeTime === null || closeTime === void 0 ? void 0 : closeTime.includes(":00")) closeTime = closeTime === null || closeTime === void 0 ? void 0 : closeTime.split(":")[0];
        return "".concat(openTime, " h \xe0 ").concat(closeTime, " h");
    }
    var localeTime = "".concat(tConvert(openTime), " - ").concat(tConvert(closeTime));
    if (text) {
        return "".concat(text, " ").concat(localeTime);
    }
    return localeTime;
};
/* harmony default export */ __webpack_exports__["Z"] = (convertTimeFormat);


/***/ }),

/***/ 66115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
;// CONCATENATED MODULE: ./public/images/error_404.png
/* harmony default export */ var error_404 = ({"src":"/_next/static/media/error_404.4affbd23.png","height":351,"width":392,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEVMaXHKz8qut7DQ0dDo5Oiqrau0t7XDxMTp6ene4t/j4eLU1NPq6urV69nv7O+cn53ExMTAwMCWuZ2HuJDw7vDY2NhoiG7M0c3t7O3IyMjVW7GeAAAAGnRSTlMA0TyoE1sqatP8loX64n97+k3EbtfkHLyeeahqT8IAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA7SURBVHicJcZHEsAgDASwpdoGAqmU/3+UIegkIMvBWCwV9wf2pB0tkS6PB85E/hRu1fxISfByqLoHMwEojQGsDYEEFQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/pages/404.tsx












var PageNotFound = function() {
    var locale = (0,router.useRouter)().locale;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var isContext = !!headerFooter[0];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sv-page-content error-page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-6 col-md-9 col-sm-12 mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-brief",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "error-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "(max-width: 375px) 220px, (max-width: 576px) 395px, (max-width: 768px) 400px, (max-width: 992px) 400px, (max-width: 1280px) 400px",
                                    src: error_404,
                                    alt: "404",
                                    className: "img-fluid",
                                    height: "300",
                                    width: "300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "error-heading",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-msg"
                                    }),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "para",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "pnf-desc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/self-storage",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn sv-primary-red-btn",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-find"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var _404 = (PageNotFound);


/***/ }),

/***/ 53461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _location_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/Canonical.tsx
var Canonical = __webpack_require__(83664);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/services/home/index.ts
var home = __webpack_require__(66156);
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/pages/404.tsx + 1 modules
var _404 = __webpack_require__(66115);
;// CONCATENATED MODULE: ./src/components/store-locator/city-component.tsx
/* eslint-disable */ 




var CityLandingComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(395), __webpack_require__.e(1909), __webpack_require__.e(5675), __webpack_require__.e(223), __webpack_require__.e(7878), __webpack_require__.e(1959)]).then(__webpack_require__.bind(__webpack_require__, 51401));
});







var CityComponent = function(props) {
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var vehicleLandingPage = props.vehicleLandingPage;
    var ref = (0,react.useState)([]), unitsInfo = ref[0], setUnitsInfo = ref[1];
    var ref1 = (0,react.useState)(), cityInfo = ref1[0], setCityInfo = ref1[1];
    var ref2 = (0,react.useState)(null), brandCta = ref2[0], setBrandCta = ref2[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var ref3 = (0,react.useState)(), ordinate = ref3[0], setOrdinate = ref3[1];
    var locale = (0,next_router.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var ref4 = (0,react.useState)(false), err = ref4[0], setErr = ref4[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands, Cta;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        Cta = brands && brands[0] && brands[0].attributes && brands[0].attributes.CTA_Section;
                        setBrandCta(Cta);
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var obj = {
            lat: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref = cityInfo.attributes) === null || ref === void 0 ? void 0 : ref.Latitude),
            lng: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref1 = cityInfo.attributes) === null || ref1 === void 0 ? void 0 : ref1.Longitude)
        };
        setOrdinate(obj);
        return function() {
            mapCords.setLatLogCity({});
        };
    }, []);
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, defaultBrand, slug, cityResult, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        slug = props === null || props === void 0 ? void 0 : props.city;
                        if (locale === "fr") {
                            defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                            slug = "".concat(props === null || props === void 0 ? void 0 : props.city, "-fr");
                        }
                        return [
                            4,
                            Promise.all([
                                (0,home/* getRightUnitInfo */.Zy)(defaultBrand, locale),
                                vehicleLandingPage ? (0,home/* getVehicleLandingData */.co)(slug, defaultBrand, locale) : (0,home/* getCityLandingInfo */.fC)(slug, defaultBrand, locale)
                            ])
                        ];
                    case 1:
                        cityResult = _state.sent();
                        setUnitsInfo((ref = cityResult[0]) === null || ref === void 0 ? void 0 : ref.data);
                        setCityInfo((ref1 = cityResult[1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.data[0]);
                        newArray = [
                            {
                                lan: (ref5 = (ref3 = cityResult[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.data[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : ref6.locale,
                                slugValue: (ref9 = (ref7 = cityResult[1]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.data[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.Slug
                            },
                            {
                                lan: (ref16 = (ref13 = (ref11 = cityResult[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.data[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.localizations) === null || ref15 === void 0 ? void 0 : ref15.data[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.attributes) === null || ref17 === void 0 ? void 0 : ref17.locale,
                                slugValue: (ref23 = (ref20 = (ref18 = cityResult[1]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : ref19.data[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                            }
                        ];
                        if (newArray[0].lan) {
                            sessionStorage.setItem("facCords", JSON.stringify(newArray));
                        }
                        if (((ref25 = cityResult[1]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : ref27.length) === 0) {
                            setErr(true);
                        } else {
                            setErr(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !err && cityInfo && brandCta && unitsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityLandingComponent, {
                cords: ordinate,
                cityLandingInfo: cityInfo,
                ourBrandsData: brandCta,
                bodyData: unitsInfo,
                hostUrl: props === null || props === void 0 ? void 0 : props.hostUrl,
                vehicleLandingPage: vehicleLandingPage
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var city_component = (CityComponent);

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



// EXTERNAL MODULE: ./src/components/invendr-section/invendr.tsx
var invendr = __webpack_require__(18228);
;// CONCATENATED MODULE: ./src/components/store-locator/facility-component.tsx
/* eslint-disable */ 





var LocationLanding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(1909), __webpack_require__.e(696), __webpack_require__.e(804), __webpack_require__.e(4544), __webpack_require__.e(3752), __webpack_require__.e(5675), __webpack_require__.e(4223), __webpack_require__.e(9921)]).then(__webpack_require__.bind(__webpack_require__, 24077));
});






var FacilityComponent = function(props) {
    var ref, ref1;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var headerInfo = (ref = headerFooterData === null || headerFooterData === void 0 ? void 0 : headerFooterData.headerFooter[0]) === null || ref === void 0 ? void 0 : ref.attributes;
    var ref2 = (0,react.useState)(null), facilityInfo = ref2[0], setFaciltyInfo = ref2[1];
    var ref3 = (0,react.useState)(null), articleInfo = ref3[0], setArticleInfo = ref3[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var facilityData = props === null || props === void 0 ? void 0 : props.facilityData;
    var reviewsData = props.reviewsData, unitData = props.unitData, promotions = props.promotions;
    var locale = (0,next_router.useRouter)().locale;
    var invendrKey = (facilityInfo === null || facilityInfo === void 0 ? void 0 : (ref1 = facilityInfo.attributes) === null || ref1 === void 0 ? void 0 : ref1.Invendr_Profile_Key) || constants/* INVENDR_KEY_HOMEPAGE */.tW;
    var isContext = !!headerFooter[0];
    var location = props === null || props === void 0 ? void 0 : props.facility;
    var ref4 = (0,react.useState)(false), err = ref4[0], setErr = ref4[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                brands = props === null || props === void 0 ? void 0 : (ref = props.brandData) === null || ref === void 0 ? void 0 : ref.data;
                headerFooterData.setHeaderFooterData(brands);
                return [
                    2
                ];
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, matched, ref25, ref26, coords, splicedStr, frSlug, enSlug, split, ref27, facilitySlugResData, ref28, ref29, ref30, ref31, ref32, citySlug, multiFacility, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (locale === "fr") {
                    if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) location = "".concat(props === null || props === void 0 ? void 0 : props.facility, "-fr");
                    else location = "".concat(props === null || props === void 0 ? void 0 : props.facility);
                }
                matched = false;
                if (sessionStorage.getItem("facCords")) {
                    ;
                    coords = JSON.parse(sessionStorage.getItem("facCords"));
                    ;
                    frSlug = (ref25 = coords.find(function(e) {
                        return e.lan === "fr";
                    })) === null || ref25 === void 0 ? void 0 : ref25.slugValue;
                    enSlug = (ref26 = coords.find(function(e) {
                        return e.lan === "en";
                    })) === null || ref26 === void 0 ? void 0 : ref26.slugValue;
                    split = frSlug.split("-");
                    splicedStr = split.slice(0, split.length - 1).join("-");
                    if (splicedStr === (props === null || props === void 0 ? void 0 : props.facility) || enSlug === (props === null || props === void 0 ? void 0 : props.facility)) {
                        if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) matched = true;
                    }
                    if (matched) {
                        ;
                        location = (ref27 = coords.find(function(e) {
                            return e.lan === locale;
                        })) === null || ref27 === void 0 ? void 0 : ref27.slugValue;
                    }
                }
                facilitySlugResData = facilityData;
                // Blog related information based on facility,city or default.
                if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref = facilitySlugResData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Blog) === null || ref1 === void 0 ? void 0 : ref1.data) !== null) {
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : facilitySlugResData.attributes);
                } else if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref2 = facilitySlugResData.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Blog) === null || ref3 === void 0 ? void 0 : ref3.data) === null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref4 = facilitySlugResData.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.City) === null || ref5 === void 0 ? void 0 : ref5.data) !== null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref6 = facilitySlugResData.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.City) === null || ref7 === void 0 ? void 0 : ref7.data.hasOwnProperty("attributes")) && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref8 = facilitySlugResData.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.City) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Blog) === null || ref12 === void 0 ? void 0 : ref12.data) !== null) {
                    ;
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref28 = facilitySlugResData.attributes) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.City) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.data) === null || ref30 === void 0 ? void 0 : ref30.attributes);
                } else {
                    ;
                    setArticleInfo((ref32 = props === null || props === void 0 ? void 0 : (ref31 = props.brandData) === null || ref31 === void 0 ? void 0 : ref31.data[0]) === null || ref32 === void 0 ? void 0 : ref32.attributes);
                }
                citySlug = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref13 = facilitySlugResData.attributes) === null || ref13 === void 0 ? void 0 : ref13.City_Slug;
                multiFacility = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref14 = facilitySlugResData.attributes) === null || ref14 === void 0 ? void 0 : ref14.multiFacility;
                if (facilitySlugResData && Object.keys(facilitySlugResData).length === 0 || multiFacility && citySlug !== (props === null || props === void 0 ? void 0 : props.city) && citySlug != undefined || facilitySlugResData === undefined) {
                    setErr(true);
                } else {
                    setErr(false);
                }
                setFaciltyInfo(facilitySlugResData);
                newArray = [
                    {
                        lan: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref15 = facilitySlugResData.attributes) === null || ref15 === void 0 ? void 0 : ref15.locale,
                        slugValue: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref16 = facilitySlugResData.attributes) === null || ref16 === void 0 ? void 0 : ref16.Slug
                    },
                    {
                        lan: (ref19 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref17 = facilitySlugResData.attributes) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.localizations) === null || ref18 === void 0 ? void 0 : ref18.data[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.attributes) === null || ref20 === void 0 ? void 0 : ref20.locale,
                        slugValue: (ref23 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref21 = facilitySlugResData.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                    }
                ];
                if (newArray[0].lan && (props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) {
                    sessionStorage.setItem("facCords", JSON.stringify(newArray));
                    api.set("facCords", JSON.stringify(newArray));
                }
                return [
                    2
                ];
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location,
        props === null || props === void 0 ? void 0 : props.facilityData
    ]);
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        return function() {
            mapCords.setLatLog({});
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            invendrKey && !err && /*#__PURE__*/ (0,jsx_runtime.jsx)(invendr/* default */.Z, {
                invendrKey: invendrKey,
                pageKey: "facility"
            }),
            facilityInfo && !err && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationLanding, {
                    facilityData: facilityInfo,
                    brandRelatedData: headerInfo,
                    articlesData: articleInfo,
                    reviewsData: reviewsData,
                    unitData: unitData,
                    promotions: promotions
                })
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var facility_component = (FacilityComponent);

// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
;// CONCATENATED MODULE: ./src/components/client-hub/api.tsx


var headers = new Headers({
    "Content-Type": "application/json",
    Accept: "application/json"
});
var clientHubTrack = function(body) {
    var env = window.location.href.includes("depotium.com") ? "production" : "staging";
    var apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/track" : "https://datavault-express-stg.storagevaultcanada.com/clientHub/track";
    fetch(apiUrl, {
        headers: headers,
        method: "POST",
        body: JSON.stringify(body)
    }).catch(function(err) {
        // eslint-disable-next-line no-console
        console.error("Tracking request failed:", err);
    });
};
var clientHubContact = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var env, apiUrl, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    env = window.location.href.includes("depotium.com") ? "production" : "staging";
                    apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/contact/new" : "https://datavault-express-stg.storagevaultcanada.com/clientHub/contact/new";
                    return [
                        4,
                        fetch(apiUrl, {
                            headers: headers,
                            method: "POST",
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {
                        ok: response.ok,
                        status: response.status
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.body = _state.sent(), _tmp)
                    ];
            }
        });
    });
    return function clientHubContact(body) {
        return _ref.apply(this, arguments);
    };
}();
var clientHubRefer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var env, apiUrl, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    env = window.location.href.includes("depotium.com") ? "production" : "staging";
                    apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/referral/new" : "https://datavault-express-stg.datavault.services/clientHub/referral/new";
                    return [
                        4,
                        fetch(apiUrl, {
                            headers: headers,
                            method: "POST",
                            body: JSON.stringify(body)
                        }).catch(function(error) {
                            return {
                                ok: false,
                                status: 500,
                                json: function() {
                                    return "Error: ".concat(error);
                                }
                            };
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {
                        ok: response.ok,
                        status: response.status
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.body = _state.sent(), _tmp)
                    ];
            }
        });
    });
    return function clientHubRefer(body) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DialpadOutlined.js
var DialpadOutlined = __webpack_require__(30677);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HelpCenterOutlined.js
var HelpCenterOutlined = __webpack_require__(95502);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalPhoneOutlined.js
var LocalPhoneOutlined = __webpack_require__(8987);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PaymentOutlined.js
var PaymentOutlined = __webpack_require__(12192);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RecommendOutlined.js
var RecommendOutlined = __webpack_require__(59744);
;// CONCATENATED MODULE: ./src/components/client-hub/mobile-footer.tsx








var menuItemStaticStyle = {
    height: "80px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "80%",
    width: "20%"
};
var menuIconStyle = {
    height: "48px",
    lineHeight: "60px",
    fontSize: "50px"
};
var menuItemColor = {
    selected: "rgba(240, 248, 255, 1)",
    default: "rgba(240, 248, 255, 0.5)"
};
var translations = {
    en: {
        contact: "Contact",
        payments: "Payments",
        access: "Access",
        referrals: "Referrals",
        faqs: "FAQs"
    },
    fr: {
        contact: "Contact",
        payments: "Paiements",
        access: "Acc\xe8s",
        referrals: "Recommander",
        faqs: "FAQ"
    }
};
var ClientHubMobileFooter = function(param) {
    var scrollTo = param.scrollTo, activeSection = param.activeSection, local = param.local;
    var t = translations[local];
    var menuItemDynamicStyle = function(itemId) {
        return {
            backgroundColor: activeSection === itemId ? menuItemColor.selected : menuItemColor.default,
            boxShadow: activeSection === itemId ? "lightblue 0px 0px 24px -16px inset" : undefined
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "mobile-footer",
        className: "fixed-bottom",
        style: {
            height: "80px",
            backgroundColor: "white",
            opacity: 1,
            zIndex: 999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                height: "80px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("contact");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("contact")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPhoneOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t.contact
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("payment");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("payment")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t.payments
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("access");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("access")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialpadOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t.access
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("referral");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("referral")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t.referrals
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("faq");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("faq")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCenterOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t.faqs
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_footer = (ClientHubMobileFooter);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/access.tsx


var access_translations = {
    en: {
        title: "Unit access & access code",
        intro: "You must use your personal access code for both entry and exit.",
        findCodeHeader: "How to find your access code",
        findCodeSteps: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        margin: 0,
                        paddingLeft: "1.2em"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "Log in to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return track("Open MyAccount");
                                    },
                                    href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                                    children: "My Account"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Select your unit"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "The access code will appear below your contact information on the “Account Balance” page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Or call us for assistance"
                        })
                    ]
                })
            });
        },
        accessUnitHeader: "Accessing your unit",
        accessUnitBody: function(scrollTo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Gate hours can be found in the",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    scrollTo("contact");
                                    return false;
                                },
                                style: {
                                    textDecoration: "none"
                                },
                                children: "Contact"
                            }),
                            " ",
                            "section."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "At the keypad, enter: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*code#"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "For example, if your access code is 12345, you would enter:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*12345#"
                            })
                        ]
                    })
                ]
            });
        }
    },
    fr: {
        title: "Acc\xe8s \xe0 votre unit\xe9 et code d’acc\xe8s",
        intro: "Vous devez obligatoirement utiliser votre code d’acc\xe8s personnel pour entrer et sortir de l’installation.",
        findCodeHeader: "Comment trouver votre code d’acc\xe8s",
        findCodeSteps: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        margin: 0,
                        paddingLeft: "1.2em"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "Ouvrez une session dans",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return track("Open MonCompte");
                                    },
                                    href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                                    children: "Mon compte"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "S\xe9lectionnez votre unit\xe9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Votre code d’acc\xe8s s’affichera sous vos coordonn\xe9es sur la page \xab Solde du compte \xbb"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Ou appelez-nous pour obtenir de l’aide"
                        })
                    ]
                })
            });
        },
        accessUnitHeader: "Acc\xe9der \xe0 votre unit\xe9",
        accessUnitBody: function(scrollTo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Les heures d’acc\xe8s sont indiqu\xe9es dans la section",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    scrollTo("contact");
                                    return false;
                                },
                                style: {
                                    textDecoration: "none"
                                },
                                children: "Contact"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Sur le clavier, saisissez : ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*code#"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Par exemple, si votre code est 12345, entrez : ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*12345#"
                            })
                        ]
                    })
                ]
            });
        }
    }
};
var ClientHubAccess = function(param) {
    var isMobile = param.isMobile, scrollTo = param.scrollTo, activeSection = param.activeSection, track = param.track, sitelinkId = param.sitelinkId, local = param.local;
    var id = "access";
    var showSection = function() {
        return isMobile ? activeSection === id : true;
    };
    var t = access_translations[local];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "access",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: t.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t.intro
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t.findCodeHeader
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t.findCodeSteps(sitelinkId, track)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t.accessUnitHeader
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t.accessUnitBody(scrollTo)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var access = (ClientHubAccess);

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 10 modules
var Button = __webpack_require__(13850);
;// CONCATENATED MODULE: ./src/components/client-hub/InstallPWAButton.tsx





var InstallPWAButton_translations = {
    en: {
        buttonLabel: "Add to Home Screen",
        iosInstructions: 'To install on your iOS device:\n1. Tap the "Share" icon in your browser.\n2. Scroll down and tap "Add to Home Screen".',
        androidPromptInstructions: {
            accepted: "",
            dismissed: 'Installation cancelled.\nTo install manually:\n1. Tap the menu (⋮) in your browser.\n2. Tap "Install app" or "Add to Home screen".',
            error: 'If installation did not start:\n1. Tap the menu (⋮) in your browser.\n2. Tap "Install app" or "Add to Home screen".'
        },
        androidNoPrompt: 'To install this app:\n1. Tap the menu (⋮) in your browser.\n2. Look for "Install app" or "Add to Home Screen".',
        otherInstructions: 'To add this app to your home screen, please look for an "Add to Home Screen" or "Install" option in your browser\'s menu.',
        gotIt: "Got it"
    },
    fr: {
        buttonLabel: "Ajouter \xe0 l’\xe9cran d’accueil",
        iosInstructions: "Pour installer sur votre appareil iOS :\n1. Appuyez sur l’ic\xf4ne \xab Partager \xbb dans votre navigateur.\n2. Faites d\xe9filer vers le bas et appuyez sur \xab Ajouter \xe0 l’\xe9cran d’accueil \xbb.",
        androidPromptInstructions: {
            accepted: "",
            dismissed: "Installation annul\xe9e.\nPour l’installer manuellement :\n1. Appuyez sur le menu (⋮) dans votre navigateur.\n2. Appuyez sur \xab Installer l’application \xbb ou \xab Ajouter \xe0 l’\xe9cran d’accueil \xbb.",
            error: "Si l’installation n’a pas d\xe9marr\xe9 :\n1. Appuyez sur le menu (⋮) dans votre navigateur.\n2. Appuyez sur \xab Installer l’application \xbb ou \xab Ajouter \xe0 l’\xe9cran d’accueil \xbb."
        },
        androidNoPrompt: "Pour installer cette application :\n1. Appuyez sur le menu (⋮) dans votre navigateur.\n2. Recherchez \xab Installer l’application \xbb ou \xab Ajouter \xe0 l’\xe9cran d’accueil \xbb.",
        otherInstructions: "Pour ajouter cette application \xe0 votre \xe9cran d’accueil, veuillez rechercher une option \xab Ajouter \xe0 l’\xe9cran d’accueil \xbb ou \xab Installer \xbb dans le menu de votre navigateur.",
        gotIt: "Compris"
    }
};
var InstallPWAButton = function(param) {
    var local = param.local;
    var t = InstallPWAButton_translations[local];
    var ref = (0,react.useState)(null), deferredPrompt = ref[0], setDeferredPrompt = ref[1];
    var ref1 = (0,react.useState)(false), isAppInstalled = ref1[0], setIsAppInstalled = ref1[1];
    var ref2 = (0,react.useState)("other"), platform = ref2[0], setPlatform = ref2[1];
    var ref3 = (0,react.useState)(false), showInstructions = ref3[0], setShowInstructions = ref3[1];
    var ref4 = (0,react.useState)(""), instructionMessage = ref4[0], setInstructionMessage = ref4[1];
    // Detect PWA installation state and platform
    (0,react.useEffect)(function() {
        if (true) {
            if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true) {
                setIsAppInstalled(true);
            }
            var ua = window.navigator.userAgent.toLowerCase();
            var isIosDevice = /iphone|ipad|ipod/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 && !window.MSStream;
            if (isIosDevice) {
                setPlatform("ios");
            } else if (/android/.test(ua)) {
                setPlatform("android");
            } else {
                setPlatform("other");
            }
        }
    }, []);
    // Listen for beforeinstallprompt event (Android/other)
    (0,react.useEffect)(function() {
        if (isAppInstalled) return undefined;
        if (platform === "ios") return undefined;
        if (platform === "android" || platform === "other") {
            var handler = function(e) {
                e.preventDefault();
                setDeferredPrompt(e);
            };
            window.addEventListener("beforeinstallprompt", handler);
            return function() {
                window.removeEventListener("beforeinstallprompt", handler);
            };
        }
        return undefined;
    }, [
        isAppInstalled,
        platform
    ]);
    var handleInstallClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var outcome, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowInstructions(true);
                        if (platform === "ios") {
                            setInstructionMessage(t.iosInstructions);
                            return [
                                2
                            ];
                        }
                        if (!(platform === "android" && deferredPrompt)) return [
                            3,
                            5
                        ];
                        deferredPrompt.prompt();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            deferredPrompt.userChoice
                        ];
                    case 2:
                        outcome = _state.sent().outcome;
                        if (outcome === "accepted") {
                            setIsAppInstalled(true);
                            setShowInstructions(false);
                        } else {
                            setInstructionMessage(t.androidPromptInstructions.dismissed);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setInstructionMessage(t.androidPromptInstructions.error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setDeferredPrompt(null);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (platform === "android" && !deferredPrompt) {
                            setInstructionMessage(t.androidNoPrompt);
                        } else if (platform === "other") {
                            setInstructionMessage(t.otherInstructions);
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInstallClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isAppInstalled) {
        return null;
    }
    var canAttemptInstall = platform === "ios" || platform === "android" || platform === "other" && deferredPrompt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                style: {
                    backgroundColor: "#0aa961",
                    marginBottom: 12,
                    color: "white"
                },
                onClick: handleInstallClick,
                disabled: !canAttemptInstall,
                children: t.buttonLabel
            }),
            showInstructions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: 12,
                    padding: 12,
                    background: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    maxWidth: 300,
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: "0.9rem",
                            whiteSpace: "pre-line"
                        },
                        children: instructionMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "small",
                        style: {
                            marginTop: 12,
                            backgroundColor: "#bbb",
                            color: "#fff"
                        },
                        onClick: function() {
                            return setShowInstructions(false);
                        },
                        children: t.gotIt
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var client_hub_InstallPWAButton = (InstallPWAButton);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ContentCopyOutlined.js
var ContentCopyOutlined = __webpack_require__(46441);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components/referral/style.module.scss
var style_module = __webpack_require__(39076);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/client-hub/sections/contact-webform.tsx











var inputStyle = {
    width: "100%",
    marginBottom: "10px",
    boxSizing: "border-box",
    background: "rgba(224, 225, 227, 0.14)",
    border: "1px solid rgba(2, 35, 94, 0.2)",
    borderRadius: "4px"
};
var contact_webform_translations = {
    en: {
        labels: {
            fullName: "Full name*",
            phone: "Phone number on file*",
            email: "Email",
            message: "Message*",
            submitButton: "Submit"
        },
        successModal: {
            header: "Thank you for reaching out!",
            body: function(firstName) {
                return "We have received your message ".concat(firstName, ", and one of our team members will give you a call shortly.");
            },
            ticketLabel: "Client care ticket id:",
            queueText: "We’ve got you in queue and will reach out directly.\nTalk soon, and thank you for your patience.",
            closeButton: "Close"
        },
        errors: {
            nameRequired: constants/* NAME_FORM_ERR */.J1,
            namePattern: constants/* ENTER_CHARS_FORM_ERR */.GK,
            phoneRequired: constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE,
            phonePattern: constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE,
            emailPattern: constants/* ENTER_VALID_FORM_ERR */.P_,
            messageRequired: "Message is required"
        }
    },
    fr: {
        labels: {
            fullName: "Nom au complet*",
            phone: "T\xe9l\xe9phone associ\xe9*",
            email: "Courriel",
            message: "Message*",
            submitButton: "Soumettre"
        },
        successModal: {
            header: "Merci pour votre message !",
            body: function(firstName) {
                return "Nous avons re\xe7u votre message, ".concat(firstName, ", et un membre de notre \xe9quipe vous appellera sous peu.");
            },
            ticketLabel: "ID de ticket client :",
            queueText: "Votre demande est en file d’attente et nous vous contacterons directement.\n\xc0 bient\xf4t, et merci de votre patience.",
            closeButton: "Fermer"
        },
        errors: {
            nameRequired: constants/* NAME_FORM_ERR_FR */.Fw,
            namePattern: constants/* NAME_FORM_ERR_FR */.Fw,
            phoneRequired: constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE,
            phonePattern: constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE,
            emailPattern: constants/* EMAIL_FORM_ERR_FR */.hh,
            messageRequired: "Le message est requis"
        }
    }
};
var ClientHubContactWebform = function(param) {
    var track = param.track, facilityId = param.facilityId, local = param.local;
    var ref, ref1, ref2;
    var t = contact_webform_translations[local];
    var ref3 = (0,react.useState)(""), caseId = ref3[0], setCaseId = ref3[1];
    var ref4 = (0,react.useState)(""), fullName = ref4[0], setFullName = ref4[1];
    var ref5 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            fullName: "",
            email: "",
            phone: "",
            message: ""
        }
    }), register = ref5.register, getValues = ref5.getValues, reset = ref5.reset, trigger = ref5.trigger, errors = ref5.formState.errors;
    var formSubmissionLock = false;
    var clickSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, formIsValid, body, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (formSubmissionLock) return [
                            2
                        ];
                        formSubmissionLock = true;
                        track("Submit contact web form");
                        return [
                            4,
                            trigger()
                        ];
                    case 1:
                        formIsValid = _state.sent();
                        if (!formIsValid) {
                            // eslint-disable-next-line no-console
                            console.log("Errors found", errors);
                            formSubmissionLock = false;
                            return [
                                2
                            ];
                        }
                        body = {
                            lcode: facilityId,
                            fullName: getValues("fullName"),
                            phone: getValues("phone"),
                            email: getValues("email"),
                            message: getValues("message")
                        };
                        return [
                            4,
                            clientHubContact(body)
                        ];
                    case 2:
                        response = _state.sent();
                        if ((ref = response.body) === null || ref === void 0 ? void 0 : ref.caseId) {
                            setCaseId(response.body.caseId);
                            setFullName(body.fullName);
                        }
                        formSubmissionLock = false;
                        return [
                            2
                        ];
                }
            });
        });
        return function clickSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetForm = function() {
        reset();
        setCaseId("");
    };
    var copyToClipboard = function(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        return new Promise(function(resolve, reject) {
            if (document.execCommand("copy")) {
                resolve();
            } else {
                reject();
            }
            textArea.remove();
        });
    };
    var copyCaseId = function() {
        return copyToClipboard("".concat(t.successModal.ticketLabel, " ").concat(caseId));
    };
    // Extract first name for the modal greeting
    var firstName = fullName.trim().split(" ")[0] || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (style_module_default()).formLabel,
                                                children: t.labels.fullName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        style: inputStyle
                                                    }, register("fullName", {
                                                        required: t.errors.nameRequired,
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]{0,50}$/,
                                                            message: t.errors.namePattern
                                                        }
                                                    }))),
                                                    ((ref = errors.fullName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: errors.fullName.message
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t.labels.phone
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "tel",
                                                        id: "phone",
                                                        style: inputStyle
                                                    }, register("phone", {
                                                        required: t.errors.phoneRequired,
                                                        pattern: {
                                                            value: /^(?![01])[0-9]{10}$/,
                                                            message: t.errors.phonePattern
                                                        }
                                                    }))),
                                                    ((ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: errors.phone.message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t.labels.email
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "email",
                                            id: "email",
                                            style: inputStyle
                                        }, register("email", {
                                            required: false,
                                            pattern: {
                                                value: /^$|^\S+@\S+$/i,
                                                message: t.errors.emailPattern
                                            }
                                        })))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t.labels.message
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                            id: "message",
                                            rows: 5,
                                            style: inputStyle
                                        }, register("message", {
                                            required: t.errors.messageRequired
                                        })))
                                    }),
                                    ((ref2 = errors.message) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "error-msg text-end",
                                        children: errors.message.message
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            margin: "10px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "contained",
                            style: {
                                backgroundColor: "#0aa961",
                                marginBottom: 12,
                                color: "white"
                            },
                            onClick: function() {
                                return clickSubmit();
                            },
                            children: t.labels.submitButton
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modal",
                style: {
                    display: caseId ? "flex" : "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "lightgrey",
                            opacity: "0.5",
                            zIndex: 2000
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            position: "fixed",
                            zIndex: 3000
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "80%",
                                minHeight: "10em",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                opacity: "1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    style: {
                                        textTransform: "none"
                                    },
                                    children: t.successModal.header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t.successModal.body(firstName)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    t.successModal.ticketLabel,
                                                    " ",
                                                    caseId
                                                ]
                                            })
                                        }),
                                        " ",
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return copyCaseId();
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCopyOutlined/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        whiteSpace: "pre-line"
                                    },
                                    children: t.successModal.queueText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            cursor: "pointer",
                                            border: "2px solid lightgrey",
                                            borderRadius: "5px",
                                            padding: "8px 16px"
                                        },
                                        onClick: function() {
                                            resetForm();
                                        },
                                        children: t.successModal.closeButton
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact_webform = (ClientHubContactWebform);

// EXTERNAL MODULE: ./src/helper/convertTimeFormat.tsx
var convertTimeFormat = __webpack_require__(41165);
// EXTERNAL MODULE: ./public/images/icons/chevron-down.svg
var chevron_down = __webpack_require__(78868);
;// CONCATENATED MODULE: ./src/components/client-hub/sections/contact.tsx







var siteUrl = "https://www.depotium.com";
var ClientHubContact = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, facilityData = props.facilityData, local = props.local;
    var id = "contact";
    var Address = facilityData === null || facilityData === void 0 ? void 0 : facilityData.Address;
    var ref10 = (0,react.useState)(false), expandOfficeHours = ref10[0], setExpandOfficeHours = ref10[1];
    var officeHours = function(dayOfWeek) {
        return (0,convertTimeFormat/* default */.Z)(facilityData.Store_Hours[dayOfWeek], local);
    };
    var ref11 = (0,react.useState)(false), expandGateHours = ref11[0], setExpandGateHours = ref11[1];
    var gateHours = function(dayOfWeek) {
        return (0,convertTimeFormat/* default */.Z)(facilityData.Open_Hours[dayOfWeek], local);
    };
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var ref12 = (0,react.useState)(false), showWebForm = ref12[0], setShowWebForm = ref12[1];
    var toggleWebForm = function() {
        if (!showWebForm) track("Expand contact web form");
        setShowWebForm(!showWebForm);
    };
    if (!facilityData) return null;
    var t = {
        welcome: local === "fr" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "C’est un plaisir de vous accueillir \xe0",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        constants/* BRAND_TITLE.FR */.tH.FR,
                        " – ",
                        (facilityData === null || facilityData === void 0 ? void 0 : facilityData.Title) || ""
                    ]
                }),
                ". C’est ici que vous trouverez tout ce dont vous avez besoin pour",
                " ",
                "commencer votre exp\xe9rience d'entreposage."
            ]
        }) : "We are excited to welcome you to ".concat(constants/* BRAND_TITLE.EN */.tH.EN, " – ").concat((facilityData === null || facilityData === void 0 ? void 0 : facilityData.Title) || "", ". Here you can find everything you need to get started."),
        contactUs: local === "fr" ? "Nous joindre" : "Contact us",
        supportText: local === "fr" ? "Nous sommes l\xe0 pour vous accompagner \xe0 chaque \xe9tape." : "We are here to support you at every step.",
        byPhone: local === "fr" ? "Par t\xe9l\xe9phone" : "By phone",
        byWebForm: local === "fr" ? "Par formulaire Web" : "By web form",
        address: local === "fr" ? "Adresse" : "Address",
        website: local === "fr" ? "Site Web" : "Website",
        officeHours: local === "fr" ? "Heures d’ouverture du bureau" : "Office hours",
        gateHours: local === "fr" ? "Heures d'acc\xe8s \xe0 l’installation" : "Gate hours"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "30px"
                },
                children: t.welcome
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return track("Install app");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_hub_InstallPWAButton, {
                        local: local
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "contact",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: t.contactUs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.supportText,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                t.byPhone,
                                ":",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    onClick: function() {
                                        return track("Call store");
                                    },
                                    href: "tel:".concat(facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.Support) === null || ref === void 0 ? void 0 : ref.Phone_Number),
                                    children: facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.Support) === null || ref1 === void 0 ? void 0 : ref1.Phone_Number
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: toggleWebForm,
                        style: {
                            padding: "20px 0 10px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                t.byWebForm,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    onClick: function(e) {
                                        e.preventDefault();
                                        return false;
                                    },
                                    href: "#"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: chevron_down/* default.src */.Z.src,
                                    style: {
                                        transform: showWebForm ? "rotateX(180deg)" : "",
                                        filter: "invert(44%) sepia(71%) saturate(5305%) hue-rotate(183deg) brightness(99%) contrast(101%)"
                                    },
                                    alt: "chevron-down"
                                })
                            ]
                        })
                    }),
                    showWebForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_webform, {
                            track: track,
                            facilityId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID,
                            local: local
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t.address,
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: function() {
                                            return track("Open store directions");
                                        },
                                        href: "https://www.google.com/maps/search/?api=1&query=%20&query_place_id=".concat(facilityData === null || facilityData === void 0 ? void 0 : facilityData.Google_PlaceID),
                                        children: [
                                            Address === null || Address === void 0 ? void 0 : Address.Street_1,
                                            " ",
                                            Address === null || Address === void 0 ? void 0 : Address.Street_2,
                                            ", ",
                                            Address === null || Address === void 0 ? void 0 : Address.City,
                                            " ",
                                            Address === null || Address === void 0 ? void 0 : Address.Postal_Code
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    paddingTop: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            t.website,
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: function() {
                                            return track("Open store page");
                                        },
                                        href: "".concat(siteUrl, "/").concat(local, "/self-storage/").concat((facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.City) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.Slug) ? "".concat(facilityData === null || facilityData === void 0 ? void 0 : (ref5 = facilityData.City) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Slug) === null || ref8 === void 0 ? void 0 : ref8.replace("-fr", ""), "/") : "").concat(facilityData === null || facilityData === void 0 ? void 0 : (ref9 = facilityData.Slug) === null || ref9 === void 0 ? void 0 : ref9.replace("-fr", ""), "/"),
                                        children: [
                                            local === "en" ? constants/* BRAND_TITLE.EN */.tH.EN : constants/* BRAND_TITLE.FR */.tH.FR,
                                            " –",
                                            " ",
                                            (facilityData === null || facilityData === void 0 ? void 0 : facilityData.Title) || ""
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setExpandOfficeHours(!expandOfficeHours);
                                },
                                style: {
                                    paddingTop: "10px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        t.officeHours,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: chevron_down/* default.src */.Z.src,
                                            style: {
                                                transform: expandOfficeHours ? "rotateX(180deg)" : ""
                                            },
                                            alt: "chevron-down"
                                        }),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: expandOfficeHours ? "block" : "none",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Lundi" : "Monday",
                                            ": ",
                                            officeHours("Monday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Mardi" : "Tuesday",
                                            ": ",
                                            officeHours("Tuesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Mercredi" : "Wednesday",
                                            ":",
                                            " ",
                                            officeHours("Wednesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Jeudi" : "Thursday",
                                            ": ",
                                            officeHours("Thursday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Vendredi" : "Friday",
                                            ": ",
                                            officeHours("Friday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Samedi" : "Saturday",
                                            ":",
                                            " ",
                                            officeHours("Saturday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Dimanche" : "Sunday",
                                            ": ",
                                            officeHours("Sunday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setExpandGateHours(!expandGateHours);
                                },
                                style: {
                                    paddingTop: "10px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        t.gateHours,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: chevron_down/* default.src */.Z.src,
                                            style: {
                                                transform: expandGateHours ? "rotateX(180deg)" : ""
                                            },
                                            alt: "chevron-down"
                                        }),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: expandGateHours ? "block" : "none",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Lundi" : "Monday",
                                            ": ",
                                            gateHours("Monday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Mardi" : "Tuesday",
                                            ": ",
                                            gateHours("Tuesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Mercredi" : "Wednesday",
                                            ":",
                                            " ",
                                            gateHours("Wednesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Jeudi" : "Thursday",
                                            ": ",
                                            gateHours("Thursday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Vendredi" : "Friday",
                                            ": ",
                                            gateHours("Friday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Samedi" : "Saturday",
                                            ": ",
                                            gateHours("Saturday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            local === "fr" ? "Dimanche" : "Sunday",
                                            ": ",
                                            gateHours("Sunday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var contact = (ClientHubContact);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/client-hub/sections/faq.tsx





var faq_translations = {
    en: {
        faqTitle: "FAQs",
        multipleChargesQuestion: "Why do I see multiple rent charges on my bill?",
        multipleChargesAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Your account is billed every 4 weeks from your move-in date. You may see upcoming rent cycles listed on your statement — this is normal and meant for visibility. ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Important: You only need to pay for your current billing cycle. Any",
                " ",
                "future rent charges shown are not yet due. If you'd like to pay ahead,",
                " ",
                "you're welcome to — but it's not required."
            ]
        }),
        accessQuestion: "When may I access my unit?",
        accessAnswer: function(scrollTo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Gate hours can be found in the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: function(e) {
                            e.preventDefault();
                            scrollTo("contact");
                            return false;
                        },
                        style: {
                            textDecoration: "none"
                        },
                        children: "Contact"
                    }),
                    " ",
                    "section."
                ]
            });
        },
        storageTipsQuestion: "Storage tips",
        storageTipsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Here are some best practices to help you store with confidence:",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Label your boxes clearly to make items easy to find."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Cover mattresses and soft goods with plastic to protect from dust and moisture."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Keep your unit secure—never share your access code or key."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Make an inventory list and store it in a safe place for easy reference."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Keep items off the floor when possible by using pallets or protective mats."
                        })
                    ]
                })
            ]
        }),
        multipleUnitsQuestion: "What if I have more than one unit?",
        multipleUnitsAnswer: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "If you have more than one unit with us, you can see and manage all your units in one place.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Visit our secure client portal:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "My Account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Once logged in:",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "A dropdown menu with the list of all your units will be available"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Select one of your units"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "From this point forward, follow the same steps outlined in the Payments and/or Access section"
                            })
                        ]
                    })
                ]
            });
        },
        referralsQuestion: "Referrals",
        referralsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Send someone our way and get up to $100 through our referral program. It pays to be a good friend!",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Eligibility: both current and past clients are eligible to participate."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Once your friend rents the unit you will be contacted to receive your reward – usually in just a few days."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Rewards will be issued by prepaid credit card after the referral has moved into the unit and submitted all required documentation."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "Reward amount:",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    border: 1,
                                    cellPadding: 6,
                                    cellSpacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        style: {
                                                            minWidth: "4em"
                                                        },
                                                        children: "Amount"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Unit size"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "$50"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "0–100 sqft"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "$75"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "101–250 sqft"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "$100"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "Larger than 250 sqft"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        movingOutQuestion: "Moving out",
        movingOutAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Your rental is fully flexible!",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you only need the unit for part of your next cycle, just let us know one week before the start of the next billing cycle. We’ll gladly provide a one-time, pro-rated rent invoice.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Refunds are available only if you’ve moved out before the rental’s due date.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Please take all items with you at move-out. A disposal fee of $50 to $500 will apply if items are left behind after move-out."
            ]
        }),
        protectionPlanQuestion: "Protection Plan details",
        protectionPlanAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Peace of mind comes standard!",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "All rentals include automatic enrollment in our Protection Plan.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This plan offers limited coverage for specific risks like fire, theft, and certain types of water damage.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you have your own insurance, simply share proof with us to opt out.",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Coverage limits range from $2,000 to $5,000"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Some exclusions apply (e.g., mold, vermin, perishables, cash or jewelry)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Claims must be submitted promptly with documentation"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "This plan is not a replacement for personal home or renter’s insurance"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "Review full details here:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return faq_translations.en.track("Open terms of service");
                                    },
                                    href: "https://www.depotium.com/en/terms-of-service/",
                                    children: "Terms of Service"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        latePaymentQuestion: "Late payment process",
        latePaymentAnswer: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "The best way to keep your account current is to enroll in pre-authorized payment. You can sign up via our secure client portal:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "My Account"
                    }),
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        border: 1,
                        cellPadding: 6,
                        cellSpacing: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            style: {
                                                minWidth: "4em"
                                            },
                                            children: "Day"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "A late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Access is temporarily paused to the unit and the facility."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 9"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 15"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 21"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 30"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "We begin auction preparation by photographing the unit contents. If payment is made during this stage, you'll just need to replace the lock."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 45"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "A lien fee equal to one rent cycle will be added, and you’ll have until Day 89 to pay the full balance and retain your unit."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 90"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "If no payment has occurred, the unit is considered abandoned and the unit contents will be auctioned."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        },
        storingFoodQuestion: "Storing food is not allowed",
        storingFoodAnswer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "All food and edible items—including boxed, canned, pet food, and spices—can attract pests. By avoiding these in storage, we all help maintain a clean, pest-free environment."
        }),
        unsafeItemsQuestion: "Items unsafe to store",
        unsafeItemsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "For your safety and compliance, storing the following items is not allowed:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Living things, such as plants or pets — and please don’t sleep or stay in your unit."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Anything requiring power or your long-term presence inside the unit."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Items that may leak or cause damage to your unit or others. If storing a vehicle, ground covering is recommended."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Flammable, toxic, or hazardous materials, such as gas, propane, or chemicals."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Illegal items, including weapons, drugs, or stolen goods."
                        })
                    ]
                }),
                "Violating these rules may result in immediate termination of your rental agreement."
            ]
        }),
        fullTermsQuestion: "Full terms of service",
        fullTermsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "While we take every precaution to maintain a safe and secure environment, we encourage you to review your rental terms for full details on responsibility and coverage.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    style: {
                        textDecoration: "none"
                    },
                    target: "_blank",
                    rel: "noreferrer",
                    onClick: function() {
                        return faq_translations.en.track("Open terms of service");
                    },
                    href: "https://www.depotium.com/en/terms-of-service/",
                    children: "Terms of Service"
                }),
                "."
            ]
        }),
        track: function(eventName) {
            /* placeholder; replaced by prop.track at runtime */ // eslint-disable-next-line no-console
            console.log("Track: ".concat(eventName));
        }
    },
    fr: {
        faqTitle: "FAQ",
        multipleChargesQuestion: "Pourquoi ma facture compte-t-elle plusieurs frais de location?",
        multipleChargesAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Votre compte est factur\xe9 toutes les quatre (4) semaines, \xe0 compter de votre date d’emm\xe9nagement. Il est donc possible que votre relev\xe9 ou votre compte en ligne affiche des cycles de location \xe0 venir. Cela est tout \xe0 fait normal et vise \xe0 vous offrir une meilleure transparence.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Si vous n’avez pas besoin de l’unit\xe9 pour la totalit\xe9 du cycle, nous pouvons calculer votre loyer au prorata, sur une base hebdomadaire. Veuillez nous joindre avant la prochaine \xe9ch\xe9ance afin d’organiser votre paiement.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Important : Vous n’avez qu’\xe0 r\xe9gler le cycle de facturation en cours. Les frais relatifs aux futurs cycles affich\xe9s ne sont pas encore exigibles. Le paiement anticip\xe9 est possible, mais reste enti\xe8rement facultatif!"
            ]
        }),
        accessQuestion: "Quand puis-je acc\xe9der \xe0 mon unit\xe9?",
        accessAnswer: function(scrollTo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Les heures d’acc\xe8s et/ou d’ouverture de la barri\xe8re sont indiqu\xe9es dans la section",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: function(e) {
                            e.preventDefault();
                            scrollTo("contact");
                            return false;
                        },
                        style: {
                            textDecoration: "none"
                        },
                        children: "Contact"
                    }),
                    "."
                ]
            });
        },
        storageTipsQuestion: "Comment devrais-je entreposer mes articles?",
        storageTipsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Voici quelques bonnes pratiques pour entreposer vos biens en toute confiance :",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "\xc9tiquetez clairement vos bo\xeetes pour retrouver facilement vos articles."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Couvrez les matelas et textiles avec du plastique pour les prot\xe9ger de la poussi\xe8re et de l’humidit\xe9, mais ne les scellez jamais compl\xe8tement. Laissez toujours une ouverture pour permettre la circulation de l’air."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Assurez la s\xe9curit\xe9 de votre unit\xe9! Ne partagez jamais votre code d’acc\xe8s ni votre cl\xe9."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Notez le contenu de votre unit\xe9 et rangez cette liste en lieu s\xfbr."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Si possible, \xe9vitez de poser vos articles directement sur le sol. Utilisez des palettes ou des tapis."
                        })
                    ]
                })
            ]
        }),
        multipleUnitsQuestion: "Que faire si j’ai plus d’une unit\xe9?",
        multipleUnitsAnswer: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Si vous louez plusieurs unit\xe9s chez nous, elles peuvent toutes \xeatre consult\xe9es et g\xe9r\xe9es depuis un seul endroit.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Consultez notre portail client s\xe9curis\xe9 :",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "Mon compte"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Une fois connect\xe9(e) :",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Vous pourrez visualiser une liste de toutes vos unit\xe9s."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "S\xe9lectionnez l’une de vos unit\xe9s."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Suivez ensuite les m\xeames \xe9tapes que celles indiqu\xe9es dans les sections Paiements ou Acc\xe8s."
                            })
                        ]
                    })
                ]
            });
        },
        referralsQuestion: "Est-ce que Depotium a un programme de recommandation?",
        referralsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Oui! Recommandez nos services \xe0 un proche et obtenez jusqu’\xe0 100 $ gr\xe2ce \xe0 notre programme de recommandation. \xcatre un bon ami, c’est payant!",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Admissibilit\xe9 : les clients actuels, ainsi que les anciens clients, sont admissibles."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Une fois que votre ami ou un proche aura emm\xe9nag\xe9 dans son unit\xe9, nous communiquerons avec vous pour vous remettre votre r\xe9compense."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Les primes de r\xe9compense sont remises sous forme de carte de cr\xe9dit pr\xe9pay\xe9e une fois que le nouveau client a emm\xe9nag\xe9 dans l’unit\xe9 et fourni tous les documents requis."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "Montant de la prime :",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    border: 1,
                                    cellPadding: 6,
                                    cellSpacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        style: {
                                                            minWidth: "4em"
                                                        },
                                                        children: "Montant"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Taille d’unit\xe9"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "50 $"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "0–100 pi\xb2 et stationnement ext\xe9rieur"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "75 $"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "101–250 pi\xb2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "100 $"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: "250 pi\xb2 et plus"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    children: "*Certaines conditions s’appliquent."
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        movingOutQuestion: "Quelles sont les d\xe9marches \xe0 suivre lorsque je d\xe9m\xe9nage?",
        movingOutAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Vous profitez de conditions de location flexibles!",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Si vous n’avez pas besoin de votre unit\xe9 pour la totalit\xe9 du cycle suivant, veuillez nous en informer avant le d\xe9but du prochain cycle de facturation. Nous serons ravis de vous fournir une facture de location unique, calcul\xe9e au prorata.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Un remboursement est possible uniquement si l’unit\xe9 est lib\xe9r\xe9e avant la date d’\xe9ch\xe9ance de la location. Veuillez emporter tous vos effets personnels lors de votre d\xe9part, retirer le cadenas de votre unit\xe9 et informer notre \xe9quipe une fois que vous avez termin\xe9. Des frais d’\xe9limination, allant de 50 $ \xe0 500 $, seront appliqu\xe9s si des articles sont laiss\xe9s sur place apr\xe8s le d\xe9m\xe9nagement."
            ]
        }),
        protectionPlanQuestion: "En quoi consiste le \xab plan de protection \xbb?",
        protectionPlanAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "La tranquillit\xe9 d’esprit, c’est inclus!",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Toutes les locations d’unit\xe9s comprennent automatiquement l’adh\xe9sion \xe0 notre plan de protection. Ce plan offre une protection limit\xe9e contre divers risques, comme les incendies, le vol et certains types de d\xe9g\xe2ts d’eau. Si vous avez d\xe9j\xe0 votre propre assurance, vous pouvez vous d\xe9sinscrire du plan, en nous fournissant une preuve de couverture. Les protections offertes varient entre 2 500 $ et 5 000 $.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Les r\xe9clamations doivent \xeatre soumises rapidement, accompagn\xe9es des documents n\xe9cessaires et des photos. Ce plan de protection ne remplace pas une assurance habitation ou une assurance locataire personnelle.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Consultez tous les d\xe9tails ici :",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    style: {
                        textDecoration: "none"
                    },
                    target: "_blank",
                    rel: "noreferrer",
                    onClick: function() {
                        return faq_translations.fr.track("Open terms of service");
                    },
                    href: "https://tripemco.com/TripemcoSelfStorageWordings/TenantsWordingsLong.pdf#page=4",
                    children: "Conditions d’utilisation"
                })
            ]
        }),
        latePaymentQuestion: "Que se passe-t-il en cas de retard de paiement?",
        latePaymentAnswer: function(sitelinkId, track) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "La meilleure fa\xe7on de maintenir votre compte \xe0 jour est d’adh\xe9rer aux paiements automatiques. Vous pouvez vous inscrire par l’entremise de notre portail client s\xe9curis\xe9 :",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none",
                            whiteSpace: "nowrap"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "Mon compte"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        border: 1,
                        cellPadding: 6,
                        cellSpacing: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            style: {
                                                minWidth: "4em"
                                            },
                                            children: "Jour"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Des frais de retard de 5 % (minimum 5 $) sont ajout\xe9s au compte."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "L’acc\xe8s \xe0 l’unit\xe9 et aux lieux est temporairement suspendu."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 9"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Des frais de retard suppl\xe9mentaires de 5 % (minimum 5 $) sont ajout\xe9s au compte."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 15"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Des frais de retard suppl\xe9mentaires de 5 % (minimum 5 $) sont ajout\xe9s au compte."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 21"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Des frais de retard suppl\xe9mentaires de 5 % (minimum 5 $) sont ajout\xe9s au compte."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 31"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Nous commen\xe7ons \xe0 pr\xe9parer la vente aux ench\xe8res en documentant par photo le contenu de l’unit\xe9. Si vous effectuez un paiement apr\xe8s cette \xe9tape, il vous suffira de remplacer le cadenas."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 45"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Des frais de privil\xe8ge \xe9quivalents \xe0 un cycle de location seront ajout\xe9s, et vous devrez r\xe9gler le solde complet avant la date de la vente aux ench\xe8res pour conserver votre unit\xe9."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Jour 90"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Si aucun paiement n’a \xe9t\xe9 effectu\xe9, l’unit\xe9 est consid\xe9r\xe9e comme abandonn\xe9e et le contenu sera mis aux ench\xe8res."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        },
        storingFoodQuestion: "Nourriture interdite dans les unit\xe9s d’entreposage",
        storingFoodAnswer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Tous les aliments et articles comestibles — y compris les bo\xeetes, les conserves, la nourriture pour animaux et les \xe9pices — peuvent attirer des nuisibles. En \xe9vitant de stocker ces articles, nous contribuons tous \xe0 maintenir un environnement propre et sans parasites."
        }),
        unsafeItemsQuestion: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Y a-t-il des articles que je ne peux ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                    children: "pas"
                }),
                " entreposer?"
            ]
        }),
        unsafeItemsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Tous les aliments et produits comestibles sont strictement interdits. Cela comprend, mais sans s’y limiter, les produits en bo\xeete, en conserve ou p\xe9rissables, la nourriture pour animaux et les \xe9pices. Ces articles peuvent attirer des nuisibles. En \xe9vitant d’entreposer ces produits, nous contribuons tous \xe0 maintenir un environnement propre et sans parasites.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Par mesure de s\xe9curit\xe9 et par respect des r\xe8gles de l’installation, il est interdit d’entreposer les articles suivants :",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Les objets vivants ou organiques, comme les plantes, les graines, la terre, l’engrais, les animaux de compagnie et, bien entendu, les humains. (Veuillez ne pas dormir ni s\xe9journer dans votre unit\xe9 pendant de longues p\xe9riodes.)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Tout ce qui n\xe9cessite une alimentation \xe9lectrique ou votre pr\xe9sence prolong\xe9e dans l’unit\xe9."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Les articles pouvant causer des fuites ou des dommages \xe0 votre unit\xe9 ou \xe0 celles des autres. Si vous entreposez un v\xe9hicule, il est recommand\xe9 d’utiliser une protection au sol."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Les produits inflammables, toxiques ou dangereux, comme l’essence, le propane ou les produits chimiques."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Les objets ill\xe9gaux, y compris les armes, les drogues et les biens vol\xe9s."
                        })
                    ]
                }),
                "Le non-respect de ces r\xe8gles peut entra\xeener la r\xe9siliation imm\xe9diate de votre entente d’utilisation."
            ]
        }),
        fullTermsQuestion: "Conditions g\xe9n\xe9rales",
        fullTermsAnswer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Bien que nous prenions toutes les pr\xe9cautions n\xe9cessaires pour maintenir un environnement s\xe9curitaire, nous vous invitons \xe0 consulter les conditions relatives \xe0 l’entente d’utilisation pour conna\xeetre tous les d\xe9tails concernant les responsabilit\xe9s et la couverture.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    style: {
                        textDecoration: "none"
                    },
                    target: "_blank",
                    rel: "noreferrer",
                    onClick: function() {
                        return faq_translations.fr.track("Open terms of service");
                    },
                    href: "https://www.depotium.com/fr/terms-of-service/",
                    children: "Conditions d’utilisation"
                }),
                "."
            ]
        }),
        track: function(eventName) {
            /* placeholder; replaced by prop.track at runtime */ // eslint-disable-next-line no-console
            console.log("Track: ".concat(eventName));
        }
    }
};
var ClientHubFaq = function(param) {
    var isMobile = param.isMobile, activeSection = param.activeSection, track = param.track, scrollTo = param.scrollTo, sitelinkId = param.sitelinkId, local = param.local;
    var id = "faq";
    var showSection = function() {
        return isMobile ? activeSection === id : true;
    };
    // pick the correct locale bundle, and override placeholder track:
    var t = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, faq_translations[local]), {
        track: track
    });
    var ref = (0,react.useState)(false), expandMultipleCharges = ref[0], setExpandMultipleCharges = ref[1];
    var ref1 = (0,react.useState)(false), expandAccessMyUnit = ref1[0], setExpandAccessMyUnit = ref1[1];
    var ref2 = (0,react.useState)(false), expandStorageTips = ref2[0], setExpandStorageTips = ref2[1];
    var ref3 = (0,react.useState)(false), expandReferrals = ref3[0], setExpandReferrals = ref3[1];
    var ref4 = (0,react.useState)(false), expandFaqMultipleUnits = ref4[0], setExpandFaqMultipleUnits = ref4[1];
    var ref5 = (0,react.useState)(false), expandMovingOut = ref5[0], setExpandMovingOut = ref5[1];
    var ref6 = (0,react.useState)(false), expandProtectionPlan = ref6[0], setExpandProtectionPlan = ref6[1];
    var ref7 = (0,react.useState)(false), expandLatePayment = ref7[0], setExpandLatePayment = ref7[1];
    var ref8 = (0,react.useState)(false), expandItemsUnsafeToStore = ref8[0], setExpandItemsUnsafeToStore = ref8[1];
    var ref9 = (0,react.useState)(false), expandFullTermsOfService = ref9[0], setExpandFullTermsOfService = ref9[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "faq",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: t.faqTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandReferrals(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.referralsQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandReferrals ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandReferrals && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.referralsAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandAccessMyUnit(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.accessQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandAccessMyUnit ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandAccessMyUnit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.accessAnswer(scrollTo),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandStorageTips(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.storageTipsQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandStorageTips ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandStorageTips && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.storageTipsAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandItemsUnsafeToStore(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.unsafeItemsQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandItemsUnsafeToStore ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandItemsUnsafeToStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.unsafeItemsAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandProtectionPlan(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.protectionPlanQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandProtectionPlan ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandProtectionPlan && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.protectionPlanAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandMultipleCharges(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.multipleChargesQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandMultipleCharges ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandMultipleCharges && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.multipleChargesAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandLatePayment(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.latePaymentQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandLatePayment ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandLatePayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.latePaymentAnswer(sitelinkId, track),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandMovingOut(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.movingOutQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandMovingOut ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandMovingOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.movingOutAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandFaqMultipleUnits(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.multipleUnitsQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandFaqMultipleUnits ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandFaqMultipleUnits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.multipleUnitsAnswer(sitelinkId, track),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandFullTermsOfService(function(prev) {
                        return !prev;
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        t.fullTermsQuestion,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandFullTermsOfService ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        })
                    ]
                })
            }),
            expandFullTermsOfService && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.fullTermsAnswer,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ var faq = (ClientHubFaq);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/payment.tsx


var ClientHubPayment = function(props) {
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, sitelinkId = props.sitelinkId, storePhone = props.storePhone, local = props.local;
    var id = "payment";
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var t = {
        title: local === "fr" ? "Paiements" : "Payments",
        billingInfo: local === "fr" ? "La facturation se fait sur un cycle de quatre (4) semaines, \xe0 partir de votre date d’emm\xe9nagement. Vous ne devez r\xe9gler que le cycle de facturation en cours. Pour de plus amples renseignements, consultez la section FAQ." : "Accounts are billed on a 4-week cycle from your move-in date. You only need to pay the current cycle. For more information, please see the FAQs section.",
        payOnline: local === "fr" ? "Paiements en ligne" : "Pay online",
        visitPortal: local === "fr" ? "Consultez notre portail client s\xe9curis\xe9 :" : "Visit our secure client portal:",
        myAccount: local === "fr" ? "Mon compte" : "My Account",
        loginSteps: local === "fr" ? [
            "1. S\xe9lectionnez votre unit\xe9.",
            "2. Cliquez sur \xab Effectuer un paiement \xbb pour payer par carte de cr\xe9dit ou pr\xe9l\xe8vement automatique.", 
        ] : [
            "1. Select your unit",
            '2. Go to "Make a Payment" to pay by credit card or direct debit', 
        ],
        payByPhone: local === "fr" ? "Paiements par t\xe9l\xe9phone" : "Pay by phone",
        callUs: local === "fr" ? "Appelez-nous au" : "Call us at",
        phoneHelp: local === "fr" ? "et nous vous aiderons \xe0 effectuer votre paiement." : "and we’ll help process your payment."
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "payment",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: t.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t.billingInfo,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t.payOnline
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t.visitPortal,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                target: "_blank",
                                rel: "noreferrer",
                                onClick: function() {
                                    return track("Open MyAccount");
                                },
                                href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                                children: t.myAccount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            local === "fr" ? "Une fois connect\xe9(e) :" : "Once logged in:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t.loginSteps.map(function(step, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        paddingLeft: "10px",
                                        display: "block"
                                    },
                                    children: step
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t.payByPhone
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t.callUs,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                onClick: function() {
                                    return track("Call store");
                                },
                                href: "tel:".concat(storePhone),
                                children: storePhone
                            }),
                            " ",
                            t.phoneHelp,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var payment = (ClientHubPayment);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/referral.tsx












var referral_translations = {
    en: {
        referralTitle: "Referrals",
        description: "Refer a friend to Depotium and earn up to $100 when they move in. Just fill in the form below.",
        clientSectionTitle: "Your contact information",
        clientNameLabel: "Full name*",
        clientPhoneLabel: "Phone number on file*",
        clientEmailLabel: "Email",
        friendSectionTitle: "The referral information",
        friendRelationshipLabel: "Relationship to you (friend, coworker, etc)*",
        friendRelationshipDefaultSelect: "Select relationship",
        friendNameLabel: "Name*",
        friendPhoneLabel: "Phone number*",
        friendEmailLabel: "Email",
        termsText: "By submitting a referral I confirm I agree with the referral program terms in the FAQs section.",
        referButton: "Refer",
        referButtonIWasReferred: "Submit",
        successHeader: "Thank you for your referral!",
        successBody: "We'll reach out to you once {recipientName} has moved in.",
        closeButton: "Close",
        errors: {
            relationshipRequired: "Relationship required",
            nameRequired: constants/* NAME_FORM_ERR */.J1,
            namePattern: constants/* ENTER_CHARS_FORM_ERR */.GK,
            phoneRequired: constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE,
            phonePattern: constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE,
            emailPattern: constants/* ENTER_VALID_FORM_ERR */.P_
        }
    },
    fr: {
        referralTitle: "Recommandation",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Recommandez nos services \xe0 un ami et ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "obtenez jusqu’\xe0 100 $"
                }),
                " lors de son emm\xe9nagement. Il vous suffit de remplir le formulaire ci-dessous."
            ]
        }),
        clientSectionTitle: "Vos coordonn\xe9es",
        clientNameLabel: "Nom au complet*",
        clientPhoneLabel: "T\xe9l\xe9phone associ\xe9*",
        clientEmailLabel: "Courriel",
        friendSectionTitle: "Coordonn\xe9es de votre ami",
        friendSectionTitleIWasReferred: "Coordonn\xe9es de qui vous a recommand\xe9",
        friendRelationshipLabel: "Relation avec vous (ami, coll\xe8gue, etc.)*",
        friendRelationshipDefaultSelect: "S\xe9lectionner une relation",
        friendNameLabel: "Nom*",
        friendPhoneLabel: "T\xe9l\xe9phone*",
        friendEmailLabel: "Courriel",
        termsText: "En soumettant ce formulaire, je certifie avoir lu et accept\xe9 les conditions du programme de recommandation dans la section FAQ.",
        referButton: "Recommander",
        referButtonIWasReferred: "Soumettre",
        successHeaderWasReferred: "Merci de nous l'avoir fait savoir.",
        successBodyWasReferred: "Nous confirmerons vos informations et traiterons la recommandation",
        successHeader: "Merci pour votre recommandation !",
        successBody: "Nous vous contacterons une fois que {recipientName} aura emm\xe9nag\xe9.",
        closeButton: "Fermer",
        errors: {
            relationshipRequired: "Relation requis",
            nameRequired: constants/* NAME_FORM_ERR_FR */.Fw,
            namePattern: constants/* NAME_FORM_ERR_FR */.Fw,
            phoneRequired: constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE,
            phonePattern: constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE,
            emailPattern: constants/* EMAIL_FORM_ERR_FR */.hh
        }
    }
};
var relationshipOptionsByLocal = {
    en: [
        {
            value: "friend/familycoworker",
            label: "Friend, family or coworker"
        },
        {
            value: "realtor/mover",
            label: "Realtor or mover"
        },
        {
            value: "otherBusiness",
            label: "Other business"
        }, 
    ],
    fr: [
        {
            value: "friend/familycoworker",
            label: "Ami, famille ou coll\xe8gue"
        },
        {
            value: "realtor/mover",
            label: "Agent immobilier ou d\xe9m\xe9nageur"
        },
        {
            value: "otherBusiness",
            label: "Autre entreprise"
        }, 
    ]
};
var ClientHubReferral = function(param) {
    var isMobile = param.isMobile, activeSection = param.activeSection, track = param.track, lcode = param.lcode, local = param.local;
    var ref, ref1, ref2, ref3, ref4;
    var id = "referral";
    var showSection = function() {
        return isMobile ? activeSection === id : true;
    };
    var t = referral_translations[local];
    var relationshipOptions = relationshipOptionsByLocal[local];
    var ref5 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            clientFullName: "",
            clientEmail: "",
            clientPhone: "",
            friendRelationship: "",
            friendName: "",
            friendEmail: "",
            friendPhone: ""
        }
    }), register = ref5.register, getValues = ref5.getValues, reset = ref5.reset, trigger = ref5.trigger, errors = ref5.formState.errors;
    var ref6 = (0,react.useState)(""), caseId = ref6[0], setCaseId = ref6[1];
    var ref7 = (0,react.useState)(""), clientName = ref7[0], setClientName = ref7[1];
    var ref8 = (0,react.useState)(""), recipientName = ref8[0], setRecipientName = ref8[1];
    var ref9 = (0,react.useState)(""), formDisplayed = ref9[0], setFormDisplayed = ref9[1];
    var formSubmissionLock = false;
    var clickRefer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var formIsValid, isAlreadyReferred, body, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (formSubmissionLock) return [
                            2
                        ];
                        formSubmissionLock = true;
                        track("Click Refer");
                        return [
                            4,
                            trigger()
                        ];
                    case 1:
                        formIsValid = _state.sent();
                        if (!formIsValid) {
                            // eslint-disable-next-line no-console
                            console.log("Errors found", errors);
                            formSubmissionLock = false;
                            return [
                                2
                            ];
                        }
                        isAlreadyReferred = formDisplayed === "received";
                        body = {
                            lcode: lcode,
                            client: {
                                fullName: isAlreadyReferred ? getValues("friendName") : getValues("clientFullName"),
                                phone: isAlreadyReferred ? getValues("friendPhone") : getValues("clientPhone"),
                                email: isAlreadyReferred ? getValues("friendEmail") : getValues("clientEmail")
                            },
                            friend: {
                                relationship: getValues("friendRelationship"),
                                name: isAlreadyReferred ? getValues("clientFullName") : getValues("friendName"),
                                phone: isAlreadyReferred ? getValues("clientPhone") : getValues("friendPhone"),
                                email: isAlreadyReferred ? getValues("clientEmail") : getValues("friendEmail")
                            },
                            isAlreadyReferred: isAlreadyReferred
                        };
                        return [
                            4,
                            clientHubRefer(body)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status === 200) {
                            setClientName(getValues("clientFullName"));
                            setRecipientName(getValues("friendName"));
                            setCaseId("true");
                        }
                        formSubmissionLock = false;
                        return [
                            2
                        ];
                }
            });
        });
        return function clickRefer() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetForm = function() {
        reset();
        setClientName("");
        setRecipientName("");
        setCaseId("");
    };
    var copyToClipboard = function(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        return new Promise(function(resolve, reject) {
            if (document.execCommand("copy")) {
                resolve();
            } else {
                reject();
            }
            textArea.remove();
        });
    };
    var copyCaseId = function() {
        return copyToClipboard("".concat(local === "en" ? "Referral id" : "ID de r\xe9f\xe9rer", ": ").concat(caseId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modal",
                style: {
                    display: caseId ? "flex" : "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "lightgrey",
                            opacity: "0.5",
                            zIndex: 2000
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            position: "fixed",
                            zIndex: 3000
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "80%",
                                minHeight: "10em",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                opacity: "1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    style: {
                                        textTransform: "none"
                                    },
                                    children: formDisplayed === "send" ? t.successHeader : t.successHeaderWasReferred
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: formDisplayed === "send" ? t.successBody.replace("{recipientName}", recipientName) : t.successBodyWasReferred
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                        children: [
                                                            local === "en" ? "Referral id" : "ID de r\xe9f\xe9rer",
                                                            ": ",
                                                            caseId
                                                        ]
                                                    })
                                                }),
                                                " ",
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    onClick: function() {
                                                        return copyCaseId();
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCopyOutlined/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                local === "en" ? "Submitted by" : "Soumis par",
                                                ": ",
                                                clientName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                local === "en" ? "Recipient" : "Destinataire",
                                                ": ",
                                                recipientName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: local === "en" ? "Talk soon!" : "\xc0 bient\xf4t !"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            cursor: "pointer",
                                            border: "2px solid lightgrey",
                                            borderRadius: "5px",
                                            padding: "8px 16px"
                                        },
                                        onClick: function() {
                                            resetForm();
                                        },
                                        children: t.closeButton
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "referral",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: t.referralTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "20px 0"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: "10px 0",
                            margin: "0 10px",
                            textAlign: "center",
                            width: "50%",
                            backgroundColor: formDisplayed === "send" ? "rgba(240, 248, 255)" : "rgba(240, 248, 255, 0.5)",
                            boxShadow: formDisplayed === "send" ? "lightblue 0px 0px 24px -16px inset" : "",
                            borderBottom: formDisplayed === "send" ? "2px solid lightblue" : ""
                        },
                        onClick: function() {
                            return setFormDisplayed(formDisplayed === "send" ? "" : "send");
                        },
                        children: "Recommander"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: "10px 0",
                            margin: "0 10px",
                            textAlign: "center",
                            width: "50%",
                            backgroundColor: formDisplayed === "received" ? "rgba(240, 248, 255)" : "rgba(240, 248, 255, 0.5)",
                            boxShadow: formDisplayed === "received" ? "lightblue 0px 0px 24px -16px inset" : "",
                            borderBottom: formDisplayed === "received" ? "2px solid lightblue" : ""
                        },
                        onClick: function() {
                            return setFormDisplayed(formDisplayed === "received" ? "" : "received");
                        },
                        children: "On m'a recommand\xe9"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                style: {
                    display: formDisplayed === "" ? "none" : ""
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: t.clientSectionTitle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (style_module_default()).formLabel,
                                                children: t.clientNameLabel
                                            }, "name"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        style: {
                                                            width: "100%",
                                                            marginBottom: "10px",
                                                            boxSizing: "border-box",
                                                            background: "rgba(224, 225, 227, 0.14)",
                                                            border: "1px solid rgba(2, 35, 94, 0.2)",
                                                            borderRadius: "4px"
                                                        }
                                                    }, register("clientFullName", {
                                                        required: t.errors.nameRequired,
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]{0,50}$/,
                                                            message: t.errors.namePattern
                                                        }
                                                    }))),
                                                    ((ref = errors.clientFullName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: errors.clientFullName.message
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t.clientPhoneLabel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "tel",
                                                        id: "phone",
                                                        style: {
                                                            width: "100%",
                                                            marginBottom: "10px",
                                                            boxSizing: "border-box",
                                                            background: "rgba(224, 225, 227, 0.14)",
                                                            border: "1px solid rgba(2, 35, 94, 0.2)",
                                                            borderRadius: "4px"
                                                        }
                                                    }, register("clientPhone", {
                                                        required: t.errors.phoneRequired,
                                                        pattern: {
                                                            value: /^(?![01])[0-9]{10}$/,
                                                            message: t.errors.phonePattern
                                                        }
                                                    }))),
                                                    ((ref1 = errors.clientPhone) === null || ref1 === void 0 ? void 0 : ref1.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: errors.clientPhone.message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t.clientEmailLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "email",
                                            id: "email",
                                            style: {
                                                width: "100%",
                                                marginBottom: "10px",
                                                boxSizing: "border-box",
                                                background: "rgba(224, 225, 227, 0.14)",
                                                border: "1px solid rgba(2, 35, 94, 0.2)",
                                                borderRadius: "4px"
                                            }
                                        }, register("clientEmail", {
                                            required: false,
                                            pattern: {
                                                value: /^$|^\S+@\S+$/i,
                                                message: t.errors.emailPattern
                                            }
                                        })))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: formDisplayed === "send" ? t.friendSectionTitle : t.friendSectionTitleIWasReferred
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).formRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (style_module_default()).formLabel,
                                        children: t.friendRelationshipLabel
                                    }, "name"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                className: "form-select",
                                                style: {
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                    boxSizing: "border-box",
                                                    background: "rgba(224, 225, 227, 0.14)",
                                                    border: "1px solid rgba(2, 35, 94, 0.2)",
                                                    borderRadius: "4px",
                                                    padding: "0.063rem 1.25rem 0.063rem 0.75rem"
                                                }
                                            }, register("friendRelationship", {
                                                required: t.errors.relationshipRequired
                                            })), {
                                                defaultValue: "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: t.friendRelationshipDefaultSelect
                                                    }),
                                                    relationshipOptions.length ? relationshipOptions.map(function(item) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: item.value,
                                                            children: item.label
                                                        }, item.value);
                                                    }) : ""
                                                ]
                                            })),
                                            ((ref2 = errors.friendRelationship) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "error-msg text-end",
                                                children: errors.friendRelationship.message
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).formRow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (style_module_default()).formLabel,
                                        children: t.friendNameLabel
                                    }, "name"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "text",
                                                style: {
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                    boxSizing: "border-box",
                                                    background: "rgba(224, 225, 227, 0.14)",
                                                    border: "1px solid rgba(2, 35, 94, 0.2)",
                                                    borderRadius: "4px"
                                                }
                                            }, register("friendName", {
                                                required: t.errors.nameRequired,
                                                pattern: {
                                                    value: /^[a-zA-Z\s]{0,50}$/,
                                                    message: t.errors.namePattern
                                                }
                                            }))),
                                            ((ref3 = errors.friendName) === null || ref3 === void 0 ? void 0 : ref3.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "error-msg text-end",
                                                children: errors.friendName.message
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t.friendPhoneLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "tel",
                                                id: "phone",
                                                style: {
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                    boxSizing: "border-box",
                                                    background: "rgba(224, 225, 227, 0.14)",
                                                    border: "1px solid rgba(2, 35, 94, 0.2)",
                                                    borderRadius: "4px"
                                                }
                                            }, register("friendPhone", {
                                                required: t.errors.phoneRequired,
                                                pattern: {
                                                    value: /^(?![01])[0-9]{10}$/,
                                                    message: t.errors.phonePattern
                                                }
                                            }))),
                                            ((ref4 = errors.friendPhone) === null || ref4 === void 0 ? void 0 : ref4.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "error-msg text-end",
                                                children: errors.friendPhone.message
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t.friendEmailLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "email",
                                            id: "email",
                                            style: {
                                                width: "100%",
                                                marginBottom: "10px",
                                                boxSizing: "border-box",
                                                background: "rgba(224, 225, 227, 0.14)",
                                                border: "1px solid rgba(2, 35, 94, 0.2)",
                                                borderRadius: "4px"
                                            }
                                        }, register("friendEmail", {
                                            required: false,
                                            pattern: {
                                                value: /^$|^\S+@\S+$/i,
                                                message: t.errors.emailPattern
                                            }
                                        })))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    margin: "10px 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        fontSize: "small"
                                    },
                                    children: t.termsText
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "10px 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    style: {
                                        backgroundColor: "#0aa961",
                                        marginBottom: 12,
                                        color: "white"
                                    },
                                    onClick: function() {
                                        return clickRefer();
                                    },
                                    children: formDisplayed === "send" ? t.referButton : t.referButtonIWasReferred
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var referral = (ClientHubReferral);

;// CONCATENATED MODULE: ./src/components/client-hub/index.tsx












var ClientHub = function(param) {
    var facilityData = param.facilityData, local = param.local;
    var ref;
    var pageVisitLogged = (0,react.useRef)(false);
    var hideNavRef = (0,react.useRef)(undefined);
    var ref1 = (0,react.useState)(true), isMobile = ref1[0], setIsMobile = ref1[1];
    var ref2 = (0,react.useState)("contact"), activeSection = ref2[0], setActiveSection = ref2[1];
    var ref3 = (0,react.useState)(false), showStoreId = ref3[0], setShowStoreId = ref3[1];
    var scrollTo = function(elementId) {
        if (isMobile) {
            setActiveSection(elementId);
        } else {
            var element = document.getElementById(elementId);
            window.scrollTo({
                top: element.offsetTop - 90,
                left: element.offsetLeft,
                behavior: "smooth"
            });
        }
    };
    var setWebsiteFooter = function(mobileDevice) {
        var footerElements = document.getElementsByTagName("footer");
        if (footerElements.length) {
            var footer = footerElements[0];
            footer.style.display = mobileDevice ? "none" : "block";
        }
    };
    var track = function(event) {
        // eslint-disable-next-line no-console
        console.log("Tracking: ".concat(event));
        if (event === "Page visit") {
            pageVisitLogged.current = true;
        }
        var body = {
            userAgent: navigator.userAgent || "",
            isMobile: isMobile,
            event: event,
            url: window.location.href || "",
            guid: "none",
            isNewVisitor: true,
            dateOfFirstVisit: "".concat(new Date()),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
            timezoneOffset: String(new Date().getTimezoneOffset()),
            screenWidth: String(window.innerWidth),
            screenHeight: String(window.innerHeight)
        };
        clientHubTrack(body);
    };
    var setDeviceType = function() {
        var ua = window.navigator.userAgent.toLowerCase();
        var isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 && !window.MSStream; // MacIntel for iPadOS
        setWebsiteFooter(isMobileDevice);
        setIsMobile(isMobileDevice);
    };
    // useEffect(() => {
    //   if ('serviceWorker' in navigator) {
    //     // register/sw.js must live at /sw.js in production
    //     window.addEventListener('load', () => {
    //       navigator.serviceWorker
    //         .register('/sw.js')
    //         .then((reg) => {
    //           console.log('ServiceWorker registered, scope:', reg.scope);
    //         })
    //         .catch((err) => {
    //           console.error('ServiceWorker registration failed:', err);
    //         });
    //     });
    //   }
    // }, []);
    (0,react.useEffect)(function() {
        setDeviceType();
        if (pageVisitLogged.current === false) {
            track("Page visit");
        }
    }, []);
    (0,react.useEffect)(function() {
        var hideTopRightSideNav = function() {
            if (hideNavRef.current) {
                clearInterval(hideNavRef.current);
            }
            hideNavRef.current = setInterval(function() {
                var rightSideNavElements = document.getElementsByClassName("rightSide-nav");
                if (rightSideNavElements.length) {
                    var rightSideNav = rightSideNavElements[0];
                    rightSideNav.style.display = "none";
                }
            }, 500);
        };
        hideTopRightSideNav();
        return function() {
            if (hideNavRef.current) {
                clearInterval(hideNavRef.current);
                hideNavRef.current = undefined;
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.shiftKey && event.key.toUpperCase() === "L") {
                setShowStoreId(function(prev) {
                    return !prev;
                });
            }
        };
        // Add event listener on mount
        window.addEventListener("keydown", handleKeyPress);
        // Cleanup the event listener on unmount
        return function() {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: local === "fr" ? constants/* BRAND_TITLE.FR */.tH.FR : constants/* BRAND_TITLE.EN */.tH.EN
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Canonical/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center g-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        local === "fr" ? "Plateforme client " : "Client Hub",
                                        showStoreId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: {
                                                color: "lightgrey"
                                            },
                                            children: [
                                                "\xa0",
                                                facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                facilityData: facilityData,
                                local: local
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID,
                                storePhone: facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.Support) === null || ref === void 0 ? void 0 : ref.Phone_Number,
                                local: local
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(access, {
                                isMobile: isMobile,
                                scrollTo: scrollTo,
                                activeSection: activeSection,
                                track: track,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID,
                                local: local
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(referral, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                lcode: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID,
                                local: local
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                scrollTo: scrollTo,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID,
                                local: local
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_footer, {
                                scrollTo: scrollTo,
                                activeSection: activeSection,
                                local: local
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var client_hub = (ClientHub);

;// CONCATENATED MODULE: ./src/pages/self-storage/[...location]/index.tsx












var Location = function(props) {
    var ref, ref1, ref2;
    var query = (0,next_router.useRouter)().query;
    var ref3 = (0,react.useState)(false), facilityPage = ref3[0], setFacilityPage = ref3[1];
    var ref4 = (0,react.useState)(false), cityPage = ref4[0], setCityPage = ref4[1];
    var ref5 = (0,react.useState)(""), facilityName = ref5[0], setFacilityName = ref5[1];
    var ref6 = (0,react.useState)(""), cityName = ref6[0], setCityName = ref6[1];
    var facilityList = props === null || props === void 0 ? void 0 : (ref = props.cityData) === null || ref === void 0 ? void 0 : ref.data;
    var hostUrl = props.hostUrl, vehicleLandingPage = props.vehicleLandingPage, facilityData = props.facilityData, facilityInfo = props.facilityInfo, unitsresultsData = props.unitsresultsData, reviewsData = props.reviewsData, isClientHub = props.isClientHub, locale = props.locale;
    var ref7 = (0,react.useState)(null), checkQueryLen = ref7[0], setCheckQueryLen = ref7[1];
    var ref8 = (0,react.useState)(false), checkCity = ref8[0], setCheckCity = ref8[1];
    var ref9 = (0,react.useState)(false), error = ref9[0], setError = ref9[1];
    (0,react.useEffect)(function() {
        if (query && query.location && query.location.length > 2) {
            setError(true);
        } else if (query && query.location && query.location.length === 2) {
            var ref, ref1;
            setCheckQueryLen(query.location.length);
            var city = query && query.location && query.location[0];
            var name = query && query.location && query.location[1];
            setFacilityPage(true);
            setCityPage(false);
            setCityName(city);
            setFacilityName(name);
            if ((facilityList === null || facilityList === void 0 ? void 0 : facilityList.length) === 0 && (props === null || props === void 0 ? void 0 : (ref = props.facilityInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.multiFacility) == null) {
                setCheckCity(true);
            } else {
                setCheckCity(false);
            }
        } else if (query && query.location && query.location.length === 1) {
            var name1 = query && query.location && query.location[0];
            if (vehicleLandingPage) {
                setCityPage(true);
                setCityName(name1);
                setFacilityPage(false);
            } else {
                setCheckQueryLen(query.location.length);
                var filterLoc = facilityList.length === 0;
                if (filterLoc) {
                    setFacilityPage(true);
                    setFacilityName(name1);
                    setCityPage(false);
                } else {
                    setCityPage(true);
                    setCityName(name1);
                    setFacilityPage(false);
                }
            }
        }
    }, [
        query.location,
        facilityList
    ]);
    var router = (0,next_router.useRouter)();
    var seoInfo = (0,utility/* getSEOProps */.RN)(props === null || props === void 0 ? void 0 : props.seoData, router);
    if (isClientHub === true) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    noindex: true,
                    nofollow: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_hub, {
                    local: locale,
                    facilityData: facilityData
                })
            ]
        });
    }
    // Define the canonical URL, which will serve as the @id for schema merging
    var canonicalUrl = (0,utility/* getCanonicalURL */.DN)(router);
    var placeName = (facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.Address) === null || ref1 === void 0 ? void 0 : ref1.City) || "";
    var areaServedSchema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": canonicalUrl,
        areaServed: {
            "@type": "Place",
            name: placeName
        }
    };
    var faqStructuredData = (props === null || props === void 0 ? void 0 : props.seoFaqData) && (0,utility/* generateDynamicFAQ */.a4)(props === null || props === void 0 ? void 0 : (ref2 = props.seoFaqData) === null || ref2 === void 0 ? void 0 : ref2.Panel, true);
    var breadCrumbUrlList = (0,utility/* generateDynamicBCLD */.W_)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: placeName && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    // Use dangerouslySetInnerHTML to insert the raw JSON string
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(areaServedSchema)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seoInfo)),
            (props === null || props === void 0 ? void 0 : props.seoFaqData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: faqStructuredData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Canonical/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: breadCrumbUrlList
            }),
            facilityData && unitsresultsData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, (0,_object_spread/* default */.Z)({}, (0,utility/* generateLocalBusinessStructerData */.u3)(facilityData, unitsresultsData, reviewsData, router)))
            }),
            facilityPage && facilityName && facilityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(facility_component, {
                facility: facilityName,
                facilityData: facilityInfo,
                reviewsData: reviewsData,
                unitData: unitsresultsData,
                checkCity: checkCity,
                city: cityName,
                checkQueryLen: checkQueryLen,
                brandData: props === null || props === void 0 ? void 0 : props.contextData,
                promotions: props === null || props === void 0 ? void 0 : props.promotions
            }),
            cityPage && cityName && cityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(city_component, {
                city: cityName,
                hostUrl: hostUrl,
                vehicleLandingPage: vehicleLandingPage
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _location_ = (Location);


/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ }),

/***/ 39076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"howToGetRewardContainer":"style_howToGetRewardContainer__JzsF1","howToGetRewardContent":"style_howToGetRewardContent__o2vei","howToGetRewardContentItem":"style_howToGetRewardContentItem__QXi4n","howToGetRewardContentItemImg":"style_howToGetRewardContentItemImg__CMTtg","howToGetRewardContentItemTitle":"style_howToGetRewardContentItemTitle__qk4fL","howToGetRewardContentItemText":"style_howToGetRewardContentItemText__HsSOt","rewardAmount":"style_rewardAmount__bMpfx","rowTitleContainer":"style_rowTitleContainer__aJxEx","rowTitle":"style_rowTitle__iipgZ","rewardItems":"style_rewardItems__nw9L2","rewardAmountItem":"style_rewardAmountItem__i5cKv","rewardAmountItemCircle":"style_rewardAmountItemCircle__U5Mfo","rewardAmountItemCircleText":"style_rewardAmountItemCircleText__jlBn3","rewardAmountItemTitle":"style_rewardAmountItemTitle__4Lamv","rewardAmountItemText":"style_rewardAmountItemText__WAGbD","rewardSection":"style_rewardSection__cN3vJ","RecentWinnersContainer":"style_RecentWinnersContainer__XfXJP","RecentWinnersRow":"style_RecentWinnersRow__0IcmZ","RecentWinnersCount":"style_RecentWinnersCount__VAxSx","RecentWinnersCountText":"style_RecentWinnersCountText__lmoIf","RecentWinnersNames":"style_RecentWinnersNames__nDzIL","RecentWinnersNamesTitle":"style_RecentWinnersNamesTitle__DM1H0","RecentWinnersNamesItems":"style_RecentWinnersNamesItems__ZvABy","referralForm":"style_referralForm__EeN5c","referralFormFields":"style_referralFormFields___SSKm","referralFormLeft":"style_referralFormLeft__iVusH","referralFormRight":"style_referralFormRight__XfnLp","formRow":"style_formRow___NISA","formLabel":"style_formLabel__34i5U","formInput":"style_formInput__p7IWC","formBtnRow":"style_formBtnRow__u0wtw","formSubmitBtn":"style_formSubmitBtn__eWERa","formRowConsent":"style_formRowConsent__7fxJW","formRowConsentCheckBox":"style_formRowConsentCheckBox__MLpBd","cardComponentContainer":"style_cardComponentContainer__uqoY_","cardComponentContentTitle":"style_cardComponentContentTitle__V1vOD","referralPolicyContainer":"style_referralPolicyContainer__JLQRt","referralPolicyRow":"style_referralPolicyRow__Dgu8e","referralPolicyContent":"style_referralPolicyContent__L6o8A","referralBottomSection":"style_referralBottomSection__920TP","whomYouCanReferContainer":"style_whomYouCanReferContainer__crnmP","whomYouCanReferRow":"style_whomYouCanReferRow__FJ769","referralCardContainer":"style_referralCardContainer__qvxW6","referralCardLeftContainer":"style_referralCardLeftContainer__QNxbt","referralCardLogoContainer":"style_referralCardLogoContainer__9_E5s","referralCardLogo":"style_referralCardLogo___EXqf","referralCardLogoImage":"style_referralCardLogoImage__5YW_U","referralCardTitle":"style_referralCardTitle__qPn2T","referralCardLeftContainerTitleContainer":"style_referralCardLeftContainerTitleContainer__xPvKc","referralCardLeftContainerTitle":"style_referralCardLeftContainerTitle__OEgpg","referralCardLeftContainerText":"style_referralCardLeftContainerText__B7b_r","referralCardRightContainer":"style_referralCardRightContainer__XPALZ","referralCardRightContainerTopContainer":"style_referralCardRightContainerTopContainer__4X9B0","referralCardRightContainerTopContainerNameContainer":"style_referralCardRightContainerTopContainerNameContainer__LLyd5","referralCardRightContainerTopContainerNameContainerTile":"style_referralCardRightContainerTopContainerNameContainerTile__pnCjm","referralCardRightContainerTopContainerNameContainerName":"style_referralCardRightContainerTopContainerNameContainerName__dli7s","referralCardRightContainerBottomContainer":"style_referralCardRightContainerBottomContainer__ILQ1R","referralCardRightContainerBottomContainerText":"style_referralCardRightContainerBottomContainerText__i4bl3","referralPopUp":"style_referralPopUp__5Oj5U","referralPopUpContainer":"style_referralPopUpContainer__ZEr_l","referralPopUpInnerContainer":"style_referralPopUpInnerContainer___9Jpq","formInputContainer":"style_formInputContainer__LkxQe","RecentWinnersCountNumberImage":"style_RecentWinnersCountNumberImage__r4YE2","howToGetRewardContentItemReveres":"style_howToGetRewardContentItemReveres__IOky_","howToGetRewardContentImage":"style_howToGetRewardContentImage__ZS1oz","howToGetRewardTextContent":"style_howToGetRewardTextContent__sOj5t","cardComponentContentImage":"style_cardComponentContentImage____wYJ","cardComponentContentText":"style_cardComponentContentText__dWfTK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,1217,1608,1664,7536,2223,5398,5775,6156,7431,9774,2888,179], function() { return __webpack_exec__(12802); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);